import React from "react";
import { Controller } from "react-hook-form";
import { Col, Input, Label, Row } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";
import ControlledCheckBoxField from "../ControlledCheckBoxField";

interface ControlledTextFieldProps {
    label?: string;
    inputName: string;
    inputType: string;
    placeholder?: string;
    invalid?: boolean;
    control: any;
    rules?: object;
    errors?: object;
    register?: any;
    isRequired?: boolean;
    hasSideLabel?: boolean;
    sideLabel?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    className?: string;
    value?: string | FileList[] | number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    multiple?: boolean;
    convertToNumber?: boolean;
    autoComplete?: string;
    min?: string | number;
    max?: string | number;
    step?: string | number;
    // New checkbox props
    hasCheckbox?: boolean;
    checkboxInputName?: string;
    checkboxLabel?: string;
    isCheckboxDisabled?: boolean;
}

type MyInputType =
    | "text"
    | "email"
    | "password"
    | "number"
    | "tel"
    | "url"
    | "search"
    | "date"
    | "datetime-local"
    | "time"
    | "week"
    | "month"
    | "color"
    | "file";

const ControlledRowTextField: React.FC<ControlledTextFieldProps> = ({
    label,
    inputName,
    inputType,
    placeholder,
    invalid,
    control,
    rules,
    errors,
    register,
    isRequired,
    hasSideLabel,
    sideLabel,
    isDisabled,
    defaultValue,
    className,
    value,
    onChange,
    convertToNumber,
    autoComplete,
    min,
    max,
    step,
    hasCheckbox,
    checkboxInputName,
    checkboxLabel,
    isCheckboxDisabled
}) => {
    return (
        <div className="my-1">
            <Row>
                <Col lg="4">
                    <div className={`pt-1 form-label ${hasCheckbox ? 'd-flex align-items-start gap-2' : ''}`}>
                        <Label className="mb-0" htmlFor={inputName}>
                            {label} {isRequired && '*'}
                        </Label>
                        {hasCheckbox && checkboxInputName && (
                            <ControlledCheckBoxField
                                label={""}
                                inputName={checkboxInputName}
                                control={control}
                                isDisabled={isCheckboxDisabled}
                            />
                        )}                        
                    </div>
                </Col>

                <Col lg="8">
                    <Controller
                        name={inputName}
                        control={control}
                        rules={rules}
                        defaultValue={defaultValue}
                        render={({ field }) => (
                            <Input
                                id={inputName}
                                type={inputType as MyInputType}
                                placeholder={placeholder}
                                invalid={invalid}
                                disabled={isDisabled}
                                {...field}
                                value={field.value ?? ""}
                                className={className}
                                required={isRequired}
                                autoComplete={autoComplete}
                                step={step || (inputType === "number" ? "any" : undefined)}
                                min={min}
                                max={max}
                                multiple={inputType === "file" ? true : undefined}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    field.onChange(convertToNumber && inputType === "number" ? +value : value);
                                    if (onChange) {
                                        onChange(e);
                                    }
                                }}
                            />
                        )}
                    />
                    {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
                    {invalid && (
                        <ValidationMsgComponent
                            inputName={inputName}
                            invalid={invalid}
                            errors={errors}
                            rules={rules}
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default ControlledRowTextField;
